import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5632ecc4"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["href"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  height: "24px",
  viewBox: "0 0 24 24",
  width: "24px",
  fill: "#1eb5a4"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0 0h24v24H0V0z",
    fill: "none"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    id: "downalod-icon-path",
    d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2v9.67z",
    style: {"stroke-dashoffset":"10px"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("a", {
    href: _ctx.downloadLink,
    target: "_blank",
    rel: "noopener noreferrer",
    class: "install-button",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.didTapDownloadLink && _ctx.didTapDownloadLink(...args)))
  }, [
    _hoisted_2,
    _createElementVNode("div", null, _toDisplayString(_ctx.buttonTitle), 1)
  ], 8, _hoisted_1))
}